import { useState, useEffect } from "react";

import { Provider } from "react-redux";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import storage from "redux-persist/lib/storage";
// eslint-disable-next-line
// @ts-ignore
import { encryptTransform } from "redux-persist-transform-encrypt";

import { changeLanguageWithTenant } from "multitenancy/i18n";
import { initializeStore } from "store";

import { useToast } from "hooks/toast";

import { LOGOUT } from "store/modules/auth/actions/actions.types";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { loadWasm } from "utils/wasm";

const ReduxProvider = ({ children }: { children: React.ReactNode }) => {
  const { addToast } = useToast();
  const [store, setStore] = useState<any>(null);
  const [persistor, setPersistor] = useState<any>(null);

  useEffect(() => {
    loadWasm().then((secretKey: any) => {
      const encryptor = encryptTransform({
        secretKey,
        onError: () => {
          const savedLng = localStorage.getItem("userLanguage");
          localStorage.clear();
          if (savedLng) localStorage.setItem("userLanguage", savedLng);
          window.location.replace("/");
        },
      });

      const persistConfig = {
        key: "root",
        storage,
        transforms: [encryptor],
        blacklist: ["loading"],
      };

      const store = initializeStore(addToast, persistConfig);
      const persistor = persistStore(store);

      store.dispatch = ((dispatch) => (action: any) => {
        if (action.type === LOGOUT) {
          const result = dispatch(action);
          persistor.purge().then(() => {
            const savedLng = localStorage.getItem("userLanguage");
            localStorage.clear();
            if (savedLng) {
              localStorage.setItem("userLanguage", savedLng);
              changeLanguageWithTenant(savedLng);
            }
          });

          return result;
        }
        return dispatch(action);
      })(store.dispatch);

      setStore(store);
      setPersistor(persistor);
    });
  }, [addToast]);

  if (!store || !persistor) return null;

  return (
    <PersistGate loading={null} persistor={persistor}>
      <Provider store={store}>{children}</Provider>
    </PersistGate>
  );
};

export default ReduxProvider;
